export default {
  fixed: {
    position: 'fixed',
    bottom: 20,
    left: 0,
    zIndex: 9999,
  },
  sync: {
    paddingLeft: 5,
    paddingRight: 5,
    opacity: 0.5,
  },
  version: {
    color: 'white',
    marginLeft: 10,
  },
  border: {
    height: '10px',
    width: '100%',
    display: 'block',
  },
}
